import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { InlineSVGModule } from '@digilize/shared/ui/inline-svg/src';
import { TranslocoModule } from '@jsverse/transloco';
import { SnackbarComponent } from './snackbar/snackbar.component';

@NgModule({
  declarations: [SnackbarComponent],
  imports: [CommonModule, CommonModule, InlineSVGModule, TranslocoModule, MatIconModule],
  exports: [SnackbarComponent],
})
export class SharedSnackbarModule {}
